import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { StoreContext } from "../../../../Store/Provider";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import PropagateLoader from "react-spinners/PropagateLoader";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import InfiniteScroll from "react-infinite-scroller";
import CircularProgress from "@material-ui/core/CircularProgress";
import { HOST_URL, ProjectName } from "../../../../Config";
import moment from "moment";
import axios from "axios";
import "./users.css";
import Button from "@material-ui/core/Button";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { getUserData, localStoragekey } from "../../../Common/Utility/Utils";
import Switch from "@mui/material/Switch";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Users() {
  const context = useContext(StoreContext);
  const classes = useStyles();
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [hasmore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(true);
  const [severity, setSeverity] = useState("error");
  const [pageNumber, setPageNumber] = useState(1);
  const [userListData, setUserListData] = useState({
    loaded: false,
    data: [],
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };
  useEffect(() => {
    if (!userListData.loaded) {
      getdata(pageNumber);
    }

    return () => {
      context.setSearchAdmin("");
    };
  }, []);

  const getdata = async (pageNumber) => {
    const body = {
      pageNumber: pageNumber,
      pageSize: 20,
    };
    const URL = `${HOST_URL}api/User/GetAll`;
    axios
      .get(URL)
      .then((res) => {
        let hasMorecheck = res.data.length === 20 ? true : false;
        setHasMore(hasMorecheck);
        console.log(hasMorecheck, pageNumber, userListData, res.data);
        if (pageNumber === 1) {
          setUserListData({
            loaded: true,
            data: [...res.data],
          });
        } else {
          setUserListData({
            loaded: true,
            data: [...userListData.data, ...res.data],
          });
        }
        let count = pageNumber + 1;
        setPageNumber(count);
        setLoadingMore(true);
      })
      .catch((res) => {
        console.log(res);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const onReset = async (email) => {
    const URL = `${HOST_URL}api/v1/Auth/RequestResetPassword?mail=${email}`;
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };
    await axios
      .post(URL, {
        headers: header,
      })
      .then((res) => {
        if (res?.data?.Success) {
          NotificationManager.success(res?.data?.ResultMessage, "", 3000);
        } else {
          NotificationManager.error(res?.data?.ResultMessage, "", 3000);
        }
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error("Something went wrong!", "", 3000);
      });
  };

  const loadMore = () => {
    if (loadingMore) {
      getdata(pageNumber);
      setLoadingMore(false);
    }
  };

  return (
    <div className="home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main
          className={clsx(classes.content, {
            [classes.contentwidth]: context.menuBar,
            [classes.contentFullWidth]: !context.menuBar,
          })}
        >
          <div
            className="shipmentsListingHomeInner statmentScreen"
            style={{
              backgroundSize: "cover",
            }}
          >
            {!userListData.loaded ? (
              <div className="loadingClass">
                <PropagateLoader color={"#fff"} size={"1.5rem"} />
              </div>
            ) : (
              <div className="statementBody">
                <TableContainer style={{ height: "100%" }}>
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={loadMore}
                    hasMore={hasmore}
                    loader={
                      <div className="bottomLoader">
                        <CircularProgress size="1.5rem" />
                      </div>
                    }
                    useWindow={false}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>User Name</TableCell>
                          <TableCell>User Id</TableCell>
                          <TableCell>Contact</TableCell>
                          <TableCell>Organizations</TableCell>
                          <TableCell>Registered Date</TableCell>
                          {/* <TableCell>Order Access</TableCell> */}
                          <TableCell>Reset Password</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {userListData.data.map((row, index) => {
                          if (row.Email.includes(context.searchAdmin)) {
                            const uniqueClass = `rowId-${index}`;
                            const orgs = row.Organizations.map((ele, index) => {
                              if (index + 1 < row.Organizations.length) {
                                return `${ele}, `;
                              } else {
                                return ele;
                              }
                            });

                            return (
                              <TableRow
                                hover
                                key={index}
                                className={uniqueClass}
                              >
                                <TableCell
                                  title={`${row.FirstName} ${row.LastName}`}
                                >{`${row.FirstName} ${row.LastName}`}</TableCell>
                                <TableCell title={row.Email}>
                                  {row.Email}
                                </TableCell>
                                <TableCell title={row.PhoneNumber}>
                                  {row.PhoneNumber}
                                </TableCell>
                                <TableCell title={orgs}>{orgs}</TableCell>
                                <TableCell
                                  title={moment(row.RegisterDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                >
                                  {moment(row.RegisterDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                </TableCell>
                                {/* <TableCell>
                                  <Switch
                                    // checked={element.stackable === "Yes"}
                                    onChange={(event) => {
                                      // const value = event.target.checked ? "Yes" : "No";
                                      // onChange(index, "stackable", value);
                                    }}
                                    // inputProps={{ "aria-label": "controlled" }}
                                  />
                                </TableCell> */}
                                <TableCell>
                                  <Button
                                    variant="contained"
                                    className="statementDownload"
                                    onClick={() => onReset(row.Email)}
                                  >
                                    Reset
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          }

                          return null;
                        })}
                      </TableBody>
                    </Table>
                  </InfiniteScroll>
                </TableContainer>
              </div>
            )}
          </div>
        </main>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentFullWidth: {
    width: "calc(100% - 2.5rem)",
  },
  contentwidth: {
    width: "calc(100% - 16rem)",
  },
  drawerLeft: {
    width: "16rem",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default Users;
